import React from 'react';
import PropTypes from 'prop-types';

const PrintIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 13.714">
        <g>
            <path d="M13.143 2.286v-.572A1.714 1.714 0 0011.429 0H4.571a1.714 1.714 0 00-1.714 1.714v.571A2.857 2.857 0 000 5.143v3.429a2.857 2.857 0 002.857 2.857 2.286 2.286 0 002.286 2.286h5.714a2.286 2.286 0 002.286-2.286A2.857 2.857 0 0016 8.571V5.143a2.857 2.857 0 00-2.857-2.857zM4 1.714a.571.571 0 01.571-.571h6.857a.571.571 0 01.572.571v.571H4zm6.857 10.857H5.143A1.143 1.143 0 014 11.429V9.143h8v2.286a1.143 1.143 0 01-1.143 1.142zm4-4a1.714 1.714 0 01-1.714 1.714V8.571A.571.571 0 0012.571 8H3.429a.571.571 0 00-.571.571v1.714a1.714 1.714 0 01-1.714-1.714V5.143a1.714 1.714 0 011.713-1.714h10.286a1.714 1.714 0 011.714 1.714z" fill={fill} />
        </g>
    </svg>
);

PrintIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

PrintIcon.defaultProps = {
    width: '16',
    height: '13.714',
    fill: '#4b254e'
};

export default PrintIcon;
